import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const ArrowDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.778 23.778L7.222 8.222m15.556 15.556v-12m1 12h-12"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
)
